export const locale = {
    lang: 'de',
    data: {
      'ALERTS':{
        'OK':'OK'
      },
      'SHEDULE': {
        'ERROR_RE':'Das Erinnerungsdatum kann nicht vor dem Startdatum liegen',
        'TITLE1': 'Freigabedatum registrieren',
        'TITLE2': 'Erinnerung registrieren',
        'TITLE3': 'Registerabschluss',
        'ERR01':'Die Erinnerungen können nicht kleiner als der Starttag sein',
        'ERR02':'Die Erinnerungen können nicht größer sein als der Abschlusstag',
        'ERR03':'Die Erinnerungen müssen im Laufe der Umfrage',
        'ERR04':'Sie können nur 3 Erinnerungen haben',
        'ERR05':'Das Datum kann nicht kleiner sein als jetzt',
        'ERR06':'Sie haben heute bereits eine E-Mail gesendet',
        'SUC01':'Erinnerung speichern',
        'SELECT_DATE':'Wählen Sie ein Datum',
        'SAVE': 'Speichern',
        'RECORDATORIOS': 'Erinnerungen',
        'RECORDATORIO': 'Erinnerung', // Campo nuevo
        'ERRORDATE':'Das Datum kann nicht früher als jetzt sein', // Campo nuevo
        'SAMEDATE':'Die Auswahl des aktuellen Datums als Startdatum der Umfrage ist nicht erlaubt',

        'LESSDAYS_T':'Sind Sie sicher, dass Sie fortfahren möchten?',
        'LESSDAYS_I':'Sie müssen das Startdatum der Umfrage mindestens 15 Tage vor dem Start festlegen, damit die Mitarbeiter den vollständigen Kommunikationsplan erhalten.',
        'CONFLDATE_T':'Warnung!',
        'CONFLDATE_I':'Wenn Sie fortfahren, können Sie die Programmierung des Starttermins der Umfrage nicht rückgängig machen.',
        'WARNING_FECHA_UPDATE': 'Sie können nicht das heutige Datum oder ein Datum vor diesem auswählen',
        'FECHA_UPDATE_WARNING': 'Achten Sie darauf, das Abschlussdatum zu ändern',
        'FECHA_UPDATE': 'Das Abschlussdatum wurde korrekt aktualisiert',

        'FECHA': 'Datum',
        'AGREGAR': 'Hinzufügen',
        'EDITAR': 'Bearbeiten',
        'COMPLETAR_PASO': 'Schritt abschließen',
        'PASO_COMPLETADO': 'Schritt abgeschlossen',
        'LOCK':'Schritt wieder öffnen',
        'UNLOCK': 'Schritt in Bearbeitung',
        'SUBIRLOGO': 'Um Ihre Umfrage zu erstellen, müssen Sie Ihr Firmenlogo hochladen',
        'ACEPTARREQUERIMIENTOS': 'Um Ihre Umfrage zu erstellen, ist es notwendig, die technischen Anforderungen zu akzeptieren',
        'LOGOSSURVEY': 'Um Ihre Umfrage zu erstellen, müssen Sie zuerst das erforderliche Logo (s) erstellen',

        'SELECCIONE_FECHA': 'Bitte wählen Sie ein Datum',
        'DATE_REGISTERED': 'Launch Date Registered Successfully',
        'CLOSE_REGISTERED': 'Close Date Registered Successfully',
        'CLOSE_MSJ1': 'Das Abschlussdatum muss größer als das Freigabedatum sein',
        'CLOSE_MSJ2': 'Vor der Registrierung des Abschlusses muss das Freigabedatum registriert werden',
        'REMIDEROK': 'Erinnerung korrekt registriert',
        'REMIDERUPDAOK': 'Erinnerung erfolgreich aktualisiert',
        'AVIUPDAOK': 'Ordnungsgemäß aktualisierte Bekanntmachung',
        'REMIDER_MSJ1': 'Die Erinnerung muss größer als das Freigabedatum sein',
        'REMIDER_MSJ2': 'Bevor Sie eine Erinnerung registrieren, müssen Sie das Freigabedatum registrieren',
        'ESPERA_ENCUESTA': 'Warten Sie, das kann ein paar Minuten dauern',

        'ENCUESTA': 'Umfrage',
        'CREANDO_ENCUESTA': 'Umfrage erstellen...',
        'AGREGANDO_USUARIOS': 'Hinzufügen von Benutzern...',
        'AGREGANDO_SECCION1': 'NPS zur Umfrage hinzufügen...',
        'AGREGANDO_SECCION2': 'Hinzufügen von STATEMENTS zur Umfrage...',
        'AGREGANDO_SECCION3': 'CONTROL zur Umfrage hinzufügen...',
        'AGREGANDO_SECCION4': 'Hinzufügen von DEMOGRAPHICS zur Umfrage...',
        'AGREGANDO_SECCION5': 'ZUSÄTZLICH zur Umfrage hinzufügen...',
        'AGREGANDO_SECCION6': 'Hinzufügen von FORALL zur Umfrage...',
        'AGREGANDO_SECCION7': 'Offene Fragen zur Umfrage hinzufügen...',
        'REINTENTAR': 'Wiederholungsversuch',
        'ERROR_ENCUESTA': 'Fehler beim Erstellen der Umfrage',
        'ERROR_USUARIOS': 'Fehler beim Hinzufügen von Benutzern...',
        'ERROR_SECCION1': 'Fehler beim Hinzufügen von NPS zur Umfrage...',
        'ERROR_SECCION2': 'Fehler beim Hinzufügen von STATEMENTS zur Umfrage...',
        'ERROR_SECCION3': 'Fehler beim Hinzufügen von CONTROL zur Umfrage...',
        'ERROR_SECCION4': 'Fehler beim Hinzufügen von DEMOGRAPHICS zur Umfrage...',
        'ERROR_SECCION5': 'Fehler beim Hinzufügen von ADDITIONAL zur Umfrage...',
        'ERROR_SECCION6': 'Fehler beim Hinzufügen von FORALL zur Umfrage...',
        'ERROR_SECCION7': 'Fehler beim Hinzufügen von Open questions zur Umfrage...',

        'SUCCESS_ENCUESTA': 'Umfrage erfolgreich erstellt!',
        'SUCCESS_USUARIOS': 'Benutzer erfolgreich hinzugefügt!',
        'SUCCESS_SECCION1': 'NPS erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION2': 'STATEMENTS erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION3': 'KONTROLLFRAGE erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION4': 'DEMOGRAPHICS erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION5': 'ZUSATZFRAGE erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION6': 'FOR ALL erfolgreich zur Umfrage hinzugefügt!',
        'SUCCESS_SECCION7': 'Offene Fragen erfolgreich zur Umfrage hinzugefügt!',
        'BTN_CREARENCUESTA': 'Umfrage erstellen',

        'CONTINUE_FINISH': 'Umfrage erfolgreich erstellt, Sie können den Schritt beenden.',
        'LAUNCH_SURVEY': 'Bitte, erstellen Sie die Umfrage, um den Schritt abzuschließen',
        'PULSE':{
            //Shedule survey
            'MES1': ' Pulse Check Monat 1',
            'MES2': ' Pulse Check Monat 2',
            'MES3': ' Pulskontrolle Monat 3',
            'MES4': ' Pulskontrolle Monat 4',
            'MES5': ' Pulskontrolle Monat 5',
            'MES6': ' Pulskontrolle Monat 6',
            'MES7': ' Pulskontrolle Monat 7',
            'MES8': ' Pulskontrolle Monat 8',
            'MES9': ' Puls Check Monat 9',
            'MES10': ' Puls Check Monat 10',
            'MES11': ' Puls Check Monat 11',
            'MES12': ' Pulse Check Monat 12',
            'INDICA': 'Wählen Sie das Datum der Pulskontrolle',
            'INDICA_GENERA': 'Umfrage generieren',
            'SUBINDICA_GENERA':'Umfrage generieren',


             },



      },
      'SHEDULE2_0': {
        'CARDS': {
          'ERROR':'The reminder date can not be earlier than launch date',
          'PASO1': {
            'TITULO': 'Voraussetzungen',
            'INFO_PRE': 'Sie müssen erst diese Voraussetzungen erfüllen, bevor Sie die Umfrage erstellen können',
            'INFO_POST': 'Sie haben die Voraussetzungen zum Anlegen der Umfrage bereits erfüllt',
            'REQTEC': 'Technische Voraussetzungen',
            'REQTEC_TOOLTIP': 'Zu den technischen Voraussetzungen',
            'LOGO': 'Firmenlogo',
            'LOGO_TOOLTIP': 'Zum Laden des Logos klicken',

          },
          'PASO2': {
            'TITULO': 'Freigabedatum',
            'TITULO_CIERRE': 'Abschlussdatum',
            'INFO_PRE': 'Startdatum der Umfrage auswählen und aufzeichnen',
            'INFO_POST': 'Ausgewähltes Datum',
            'PICKDATE': 'Kalender öffnen',
            'INFO_POST_CIERRE': 'Aktuelles Abschlussdatum',
            'CHANGE': 'Änderungsdatum',
            'LIS-PRORRO': 'Erweiterungen',
          },
          'PASO2_B': {
            'TITULO': 'Datumsauswahl',
            'INFO_PRE': 'Wählen und registrieren Sie die verschiedenen Termine, die zur Konfiguration der Umfrage zur Verfügung stehen',
            'PICKDATE': 'Termine auswählen',
            'INFO_PROR': 'Diesem Produkt wurden Erweiterungen zugewiesen',
            'PRORROGAS': 'Siehe Erweiterungen',
            'TIUTLOLISTA': 'Erweiterungen erstellt',
            'NOPROR': 'Sie haben keine Erweiterungen zugewiesen'
          },
          'PASO3': {
            'TITULO': 'Erinnerungstermine',
            'INFO_PRE': 'Fügen Sie Erinnerungsabgabetermine für die Beantwortung der Umfrage hinzu',
            'INFO_POST': 'Sie haben zwei Möglichkeiten:',
            'NUEVO': 'Neue Erinnerung registrieren',
            'LISTA': 'Aufgezeichnete Erinnerungen',
            'LISTA_AVI': 'Kommunikation vor der Erhebung',
            'TITU_AVIS':'Anzeigen',
            'TIUTLOLISTA': 'Erinnerungen erstellt',
            'NORECOS': 'Sie haben keine Erinnerungen gespeichert',
            'NOAVI': 'Sie haben keine Warnungen gespeichert',
            'INFOHORA': 'HINWEIS: Jede Erinnerung wird in der Ortszeit des Instituts angezeigt:',
            'INFOHORAAVISO': 'HINWEIS: Jede Bekanntmachung wird in der Ortszeit des Instituts angezeigt:',
            'TITULOLISTA': 'Bekanntmachungen erstellt',
          },
          'PASO4': {
            'TITULO': 'Kommunikationsmeldungen',
            'INFO_PRE': 'Überprüfen Sie die Kommunikationsnachrichten, die während des Lebenszyklus der Umfrage gesendet werden sollen',
            'VERMENSAJES': 'Siehe Kommunikationsnachrichten'
          },
          'PASO5': {
            'TITULO': 'Umfrageprüfung',
            'TITULO_ALT': 'Master-Tabellenüberprüfung',
            'INFO_PRE': 'Überprüfen Sie die Abschnitte der Umfrage, sowie die Anzahl der Fragen, die in jedem Abschnitt hinzugefügt wurden',
            'VERMENSAJES': 'Siehe Abschnittsdaten',
            'FILTRAR': 'Abschnitte nach Namen filtern',
            'TABLE':{
              'SECTION': 'Abschnitt',
              'WERT': 'Wert',
              'INACTIVE':'Inaktiv',
              'ACTIVE':'Aktiv',
              'CLOSE':'Geschlossen'
            }
          },
          'PASO6': {
            'TITULO': 'Umfrage-Generierungsverlauf',
            'INFO_PRE': 'Datum der letzten Umfragegenerierung:',
            'INFO_PRE_2': 'Generierungshistorie:',
            'ERRORHISTORIAL':'Sie haben keine Historie, da die Umfrage nicht erstellt wurde'
          },
          'PASO7': {
            'TITULO': 'Umfragemerkmale',
            'INFO_PRE': 'Bevor Sie die Umfragefunktionen konfigurieren, müssen Sie zuerst die Voraussetzungen erfüllen',
            'INFO_POST_1': 'Vor dem Erstellen der Umfrage müssen die Eigenschaften der Umfrage konfiguriert werden configure',
            'INFO_POST_2': 'Sie haben bereits die notwendigen Einstellungen vorgenommen, um die Umfrage zu erstellen',
            'EMPRESA': 'Firmenlogo',
            'CERTIFICADO': 'Zertifikatslogo',
            'CARACTERISTICAS': 'Umfragemerkmale',
            'PREVIEW': 'Vorschau',
            'CAMBIAR': 'Bild ändern',
            'LOGO_EMP_INFO': 'Das Bild wird in seiner gespeicherten Auflösung von 200 x 200 Pixel angezeigt'
          },
          'MODALGEN': {
            'REGRESAR': 'Geh zurück',
            'HISTORIAL': {
              'BOTON': 'Verlauf der Umfragegenerierung',
              'TITULO': 'Verlauf der Umfragegenerierung',
              'CARGANDO': 'Generationsverlauf laden Loading',
              'ULTIMA': 'Datum der letzten Generation',
              'ANTERIORES': 'Daten der vorherigen Generation',
              'NOHISTO': 'Es gibt keine Historie der Erstellung der Umfrage'
            },
            'CERTIFICADO': {
              'TITULO': 'Zertifikatsvorschau'
            },
            'URL_QR': {
              'BOTON': 'Link im QR-Code abrufen',
              'TITULO': 'Umfragelink im QR-Code',
              'SUBTITULO': 'Durch Scannen dieses QR-Codes können Sie direkt auf die Umfrage zugreifen, ohne den Link manuell eingeben zu müssen',
              'DESCARGA': 'Um den QR-Code herunterzuladen, klicken Sie mit der rechten Maustaste auf das Bild und dann auf die Option <b> <em> Bild speichern unter ... </em> </b>',
              'REGENERARQR': 'Die URL wurde korrekt geändert. Wenn Sie einen QR-Code von der vorherigen URL haben, müssen Sie einen neuen QR-Code mit dem aktualisierten Link erhalten'
            }
          },
          'STATUS': {
            'PENDING': 'Noch nicht abgeschlossen',
            'OK': 'Fertig',
            'OPT': 'Dieser Schritt ist optional'
          },
          'FECHAS': {
            'TITULO': 'Datumsauswahl',
            'FECHA': 'Gewähltes Datum:',
            'NOTYET': 'Noch nicht ausgewählt',
            'INFO': {
              '1': 'Wählen Sie jedes der verfügbaren Daten aus, um die Umfrage zu konfigurieren.',
              '2': 'HINWEIS: Die an jedem Datum ausgewählte Zeit wird auf die Ortszeit des Instituts gesetzt:'
            },
            'TABLA': {
              'TIPO': 'Art des Datums',
              'FECHA': 'Ausgewähltes Datum',
              'ACCIONES': 'Aktionen'
            },
            'TIPOS': {
              'lanzamiento': 'Startdatum',
              'aviso1': 'Pre-launch (Erste Benachrichtigung vor dem Start der Umfrage)',
              'aviso2': 'Pre-launch (Zweite Benachrichtigung vor dem Start der Umfrage)',
              'cierre': 'Deadline',
              'recor30': 'Pre-launch (Bekanntmachung 30 Tage vor der Erhebung)',
              'recor29': 'Pre-launch (Bekanntmachung 29 Tage vor der Erhebung)',
              'recor15': 'Pre-Launch (Bekanntmachung 15 Tage vor der Erhebung)',
              'recor7': 'Pre-launch (Bekanntmachung 7 Tage vor der Erhebung)',
              'result': 'Ergebnisse:',
            },
            'BOTONES': {
              'ELEGIR': 'Datum wählen',
              'CAMBIAR': 'Datum ändern',
              'CANCELAR': 'Abbrechen',
              'ACEPTAR': 'Akzeptieren',
              'ENVIOCIERRE': 'Benachrichtigung senden'
            }
          }
        },
        'CREAR': 'Umfrage erstellen',
        'RECREAR': 'Umfrage neu erstellen',
        'ENCUESTACREADA': 'Umfrage erstellt',
        'ENCUESTAERROR': 'Die Umfrage wurde nicht korrekt erstellt',
        'VERSECCIONES': 'Siehe hinzugefügte Abschnitte',
        'BACK': 'Zurück',
        'CERRAR': 'Schließen',
        'CREANDO': 'Die Umfrage wird erstellt, warten Sie, bis jede ihrer Komponenten korrekt hinzugefügt wurde',
        'RETRY': 'Den Vorgang erneut versuchen',
        'SECCIONES': {
          'DETALLES': 'Letzte Details speichern',
          'COMPLETA': 'Die Umfrage wurde erfolgreich erstellt!',
          'ENCUESTA': {
            'TITULO': 'Umfrage',
            'PROCESO': 'Umfrage erstellen',
            'ERROR': 'Beim Erstellen der Umfrage ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut'
          },
          'USUARIOS': {
            'TITULO': 'Benutzer',
            'PROCESO': 'Hinzufügen von Benutzern zur Umfrage',
            'ERROR': 'Beim Hinzufügen der Benutzer ist ein Fehler aufgetreten, versuchen Sie den Vorgang erneut',
          },
          'NPS': {
            'TITULO': 'NPS',
            'PROCESO': 'NPS zur Umfrage hinzufügen',
            'ERROR': 'Beim Hinzufügen des NPS ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
          'REACTIVOS': {
            'TITULO': 'Anweisungen',
            'PROCESO': 'Hinzufügen von Aussagen zur Umfrage',
            'ERROR': 'Beim Hinzufügen der Aussagen ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
          'CONTROL': {
            'TITULO': 'Kontrollfrage',
            'PROCESO': 'Hinzufügen der Kontrollfrage zur Umfrage',
            'ERROR': 'Beim Hinzufügen der Kontrollfrage ist ein Fehler aufgetreten, versuchen Sie den Vorgang erneut',
          },
          'DEMOGRAFICOS': {
            'TITULO': 'Demographics',
            'PROCESO': 'Demografische Daten zur Umfrage hinzufügen',
            'ERROR': 'Beim Hinzufügen der demografischen Daten ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
          'ABIERTAS': {
            'TITULO': 'Offene Fragen',
            'PROCESO': 'Hinzufügen von offenen Fragen zur Umfrage',
            'ERROR': 'Beim Hinzufügen offener Fragen ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
          'FORALL': {
            'TITULO': 'Forall',
            'PROCESO': 'Hinzufügen von ForAll-Praktiken zur Umfrage',
            'ERROR': 'Beim Hinzufügen der ForAll-Praktiken ist ein Fehler aufgetreten, versuchen Sie den Vorgang erneut',
          },
          'ADICIONALES': {
            'TITULO': 'Zusätzlich',
            'PROCESO': 'Hinzufügen von zusätzlichen Fragen zur Umfrage',
            'ERROR': 'Beim Hinzufügen zusätzlicher Fragen ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
          'ADICIONALES-FOCUS': {
            'TITULO': 'Personalisiert',
            'PROCESO': 'Hinzufügen von benutzerdefinierten Fragen zur Umfrage',
            'ERROR': 'Beim Hinzufügen der benutzerdefinierten Fragen ist ein Fehler aufgetreten, bitte versuchen Sie den Vorgang erneut',
          },
        },
        'MODALES': {
          'ENCUESTA': {
            'CREAR_1': 'Möchten Sie die Umfrage mit der aktuellen Konfiguration erstellen?',
            'CREAR_2': 'Sobald die Umfrage erstellt ist, können Sie die Kommunikationsmeldungen nicht mehr ändern',
            'CREAR_3': 'Wollen Sie die Erstellung der Umfrage starten',
            'SINFECHA': 'Um die Umfrage zu erstellen, ist es notwendig, zuerst das Startdatum der Umfrage zu wählen',
            'CREADA_1': 'Die Umfrage wurde erfolgreich erstellt!',
            'CREADA_2': 'Sie können nun diesen Abschnitt abschließen und mit dem nächsten fortfahren',
            'RECOEXIS': 'Für den gewählten Tag ist bereits eine Erinnerung registriert',
            'RECOBEFORE': 'Sie können keine Erinnerung aufzeichnen, ohne vorher das Startdatum der Umfrage auszuwählen',
            'RECOMAX': 'Sie haben bereits alle erlaubten Erinnerungen programmiert, Sie können keine neuen mehr registrieren',
            'LASTRECO_1': 'Warnung:',
            'LASTRECO_2': 'Sie haben alle erlaubten Erinnerungen programmiert, Sie können keine neuen mehr registrieren',
            'LISTARECOBEF': 'Sie können die Erinnerungsliste nicht anzeigen, ohne vorher das Startdatum der Umfrage auszuwählen',
            'FINAL': 'Sie können diesen Abschnitt jetzt abschließen und mit dem nächsten fortfahren',
            'SAVELAUNCHDATE': 'Startdatum der Umfrage speichern, bitte warten Sie eine Weile',
            'SAVEAVISODATE': 'Benachrichtigungsdatum speichern, bitte warten Sie eine Weile',
            'AVISOOK': 'Benachrichtigungsdatum erfolgreich gespeichert',
            'CHANGELAUNCH': 'Warnung: Wenn Sie das Startdatum der Umfrage ändern, werden die restlichen Daten gelöscht und Sie müssen sie erneut auswählen, möchten Sie ein anderes Startdatum wählen?',
            'CHANGECLOSENOT': 'Der Versandstatus der Benachrichtigung wurde erfolgreich geändert',
            'GUARDANDO_LOGO': 'Bild wird gespeichert, warte einen Moment',
            'CARGA_CERT': 'Um die höchste Qualität des endgültigen Dokuments zu erzielen, laden Sie unbedingt ein Bild mit einer Mindestauflösung von 400 x 240 Pixel hoch.',
            'BORRA_RECO_1': 'Möchten Sie die Erinnerung mit dem folgenden Datum wirklich löschen?',
            'BORRA_RECO_2': 'Die Erinnerung wurde erfolgreich gelöscht',
            'BORRA_AVI_1': 'Sind Sie sicher, dass Sie die Erinnerung mit dem folgenden Datum löschen wollen?',
            'BORRA_AVI_2': 'Die Erinnerung wurde erfolgreich gemahnt',
            'UPDA_AVISO':'Aktualisierung des Erinnerungsdatums',
            'UPDA_RECOR':'Aktualisierung des Erinnerungsdatums',
            'DELE_AVISO': 'Erinnerungsdatum löschen',
            'DELE_RECOR':'Löschen des Erinnerungsdatums',
            'GUARD_RECOR':'Speicherung des Erinnerungsdatums',
            'TITL_MOD_QUES_ALEAT':'Um die Umfrage zu erstellen, müssen Sie die Validierung von Zufallsfragen aktivieren.',
            'TEXT_MOD_QUES_ALEAT_1':'Folgen Sie dann diesen Schritten:',
            'TEXT_MOD_QUES_ALEAT_2':'1.- Geben Sie die Umfragemerkmale ein und bearbeiten Sie sie.',
            'TEXT_MOD_QUES_ALEAT_3':'2.- Klicken Sie auf zusätzliche Konfiguration und aktivieren Sie die Validierung von Zufallsfragen',
          }
        },
        'CORREOS': {
          'VER': 'Siehe Meldung',
          'TIPO1': {
              'TITULO': 'Pre-launch message',
              'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage verschickt wurden',
              'TIPO_1': 'Erste Benachrichtigungsnachricht',
              'TIPO_2': 'Zweite Benachrichtigungsnachricht',
          },
          'TIPO_2': {
              'TITULO': 'Einladungsnachricht',
              'INFO': 'Dies ist die Nachricht, die am Tag des Starts der Umfrage an die Teilnehmer gesendet wird'
          },
          'TIPO3': {
              'TITULO': 'Erinnerungsnachricht',
              'INFO': 'Dies ist die Erinnerungsmeldung, die an den dafür vorgesehenen Tagen gesendet wird.'
          },
          'TIPO4': {
              'TITULO': 'Erste Benachrichtigungsnachricht',
              'INFO': ''
          },
          'TIPO5': {
              'TITULO': 'Zweite Benachrichtigungsmeldung',
              'INFO': ''
          },
          'TIPO6': {
              'TITULO': 'Nachricht über den Abschluss der Umfrage',
              'INFO': 'Dies ist die Nachricht, die am Abschlussdatum der Umfrage an die Teilnehmer gesendet wird.'
          },
          'TIPO7': {
            'TITULO': 'Nachricht an Mitarbeiter, die ihre Umfrage noch nicht gestartet haben',
            'INFO': 'Dies ist die Erinnerungsnachricht, die an Mitarbeiter gesendet wird, die ihre Umfrage noch nicht gestartet haben'
          },
          'TIPO8': {
            'TITULO': 'Nachricht an Mitarbeiter, die noch nicht fertig sind',
            'INFO': 'Dies ist die Erinnerungsnachricht, die an Mitwirkende gesendet wird, die ihre Umfrage bereits gestartet, aber noch nicht abgeschlossen haben'
          },
        },
        'EDITOR': {
          'BOTONES': {
            'INFO': 'Wichtige Information',
            'SAVE': 'Änderungen speichern',
            'EDIT': 'Nachricht bearbeiten',
          },
          'PENDING': 'In Bearbeitung',
          'MODALINFO': {
            'TITULO': 'Wichtige Informationen zum Inhalt der E-Mail',
            'PARTE_1': 'Damit die E-Mail als korrekt versendet gilt, können die folgenden Bezeichnungen im Textkörper der Nachricht enthalten sein (Achtung, die Pflichtbezeichnungen müssen mindestens einmal enthalten sein):',
            'PARTE_2': 'Der Grund hierfür liegt darin, dass die Plattform beim Eintreffen des Zustellungsdatums jeder E-Mail automatisch folgende Ersetzungen in der Nachricht vornimmt:',
            'tag_company': 'Der Firmenname',
            'tag_link': 'Der Zugangslink zur Umfrage',
            'tag_date': 'Das Startdatum der Umfrage',
            'tag_user': 'Das Zugangspasswort zur Umfrage',
            'tag_dtb': 'Tage bis zum Start der Umfrage (ab dem Datum, an dem die Nachricht gesendet wird)',
            'tag_dtc': 'Tage bis zum Ende der Umfrage (ab dem Datum, an dem die Nachricht gesendet wird)',
            'tag_end': 'Das Abschlussdatum der Umfrage',
            'tag_userAction': 'Benutzer zum Anmelden ',
            'tag_pass': 'Kennwort des Benutzers',
            'tag_linkAction': 'Der Zugangslink zu cultrural Go',
            'PARTE_3': 'Die Tags können an beliebiger Stelle im Textkörper der E-Mail platziert werden. Sobald die Tags im Inhalt vorhanden sind, kann dieser gespeichert werden.',
            'PARTE_4': 'Hinweis: Es ist möglich, dass die Nachricht von einem Projektmanager validiert werden muss, wenn dies der Fall ist, können Sie den Validierungsstatus der neuen E-Mail auf diesem Bildschirm sehen. Während des Validierungsprozesses können Sie keine neue Ausgabe der E-Mail erstellen. Andernfalls wird die E-Mail sofort als gültig betrachtet und Sie können sie erneut bearbeiten, wenn Sie dies wünschen.',
            'OPC': '(Optional)',
            'MDT': '(Obligatorisch, außer in der Abschlussmeldung)'
          },
          'MODALES': {
            'SINCAMBIOS': 'Sie haben noch keine Änderungen am Inhalt der E-Mail vorgenommen',
            'SINTAG': 'Mail kann nicht gespeichert werden, das nächste Tag wurde nicht gefunden:',
            'GUARDAR_1': 'Möchten Sie die Änderungen an der Nachricht speichern?',
            'GUARDAR_2': 'Wir erinnern Sie daran, dass die Nachricht zur Validierung gesendet wird und Sie sie erst wieder bearbeiten können, wenn der Validierungsprozess abgeschlossen ist.',
            'SAVEOK_1': 'Der Inhalt der E-Mail wurde korrekt gespeichert',
            'SAVEOK_2': 'Warten Sie auf einen Projektmanager, um die Änderungen zu validieren',
            'ENABLED': 'Ein Projektmanager hat die E-Mail-Bearbeitung wieder aktiviert, Sie können mit den Änderungen fortfahren',
            'CAMBIOIDIOMA_1': 'Achtung: Wenn Sie eine andere Sprache wählen wollen, müssen die bisherigen Änderungen in der aktuellen Sprache zuerst gespeichert werden',
            'CAMBIOIDIOMA_2': 'Möchten Sie die Änderungen speichern und eine andere Sprache wählen?',
          }
        },
        'ZONAS': {
          '1': 'Mexico City',
          '2': 'San Salvador',
          '3': 'Hong Kong',
          '4': 'Singapore',
          '5': 'Istanbul',
          '6': 'Manila',
          '11': 'Brasilia',
          '15': 'Madrid',
          '18': 'Mexico City',
        },
        'SECCIONES_ESPECIALES': {
          'TITULO': 'Diese Umfrage hat spezielle Abschnitte',
          'SUBTITULO': 'Unten sind die Demo-Benutzer gruppiert, jede Gruppe soll die Umfrage mit jedem speziellen Abschnitt separat oder die Umfrage ohne spezielle Abschnitte testen',
          'ELEGIR': 'Wählen Sie links im Menü eine Gruppe aus',
          'LISTA': {
            'TITULO': 'spezielle Abschnitte',
            'SIN_SECCION': 'Erhebung ohne Sonderschnitte'
          }
        },
        'CORREOS_NORM':{
          'TIPO1':{
            'TITULO': 'Pre-launch message',
            'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage verschickt wurden',
          },
          'TIPO2':{
            'TITULO': 'Warnmeldung: 30 Tage vor dem Start der Einladung' ,
            'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage gesendet werden'
          },
          'TIPO3':{
            'TITULO': 'Warnmeldung: 29 Tage vor dem Start der Einladung',
            'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage gesendet werden'
          },
          'TIPO4':{
            'TITULO': 'Warnmeldung: 15 Tage vor dem Start der Einladung',
            'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage gesendet werden'
          },
          'TIPO5':{
            'TITULO': 'Warnmeldung: 7 Tage vor dem Start der Einladung',
            'INFO': 'Dies sind die Nachrichten, die Tage vor dem Start der Umfrage gesendet werden'
          },
          'TIPO6': {
              'TITULO': 'Nachricht über den Abschluss der Umfrage',
              'INFO': 'Dies ist die Nachricht, die am Abschlussdatum der Umfrage an die Teilnehmer gesendet wird.'
          },
          'TIPO7':{
            'TITULO': 'Erinnerungsnachricht',
            'INFO': 'Dies ist die Erinnerungsmeldung, die an den dafür vorgesehenen Tagen gesendet wird.'
          },
        }
      }
    }
};
